/**
 * Enumeration of block types used when storing block data in the remote
 * backend so we can easily serialize and deserialize into the proper
 * constructs.
 */
let BlockTypes = /*#__PURE__*/function (BlockTypes) {
  BlockTypes["EMBED"] = "Embed";
  BlockTypes["LINK"] = "Link";
  BlockTypes["REFERENCE"] = "Reference";
  BlockTypes["RICHTEXT"] = "RichText";
  BlockTypes["YOUTUBE"] = "YouTube";
  return BlockTypes;
}({});

export { BlockTypes };
//# sourceMappingURL=block.js.map
